import Unit from "@/src/utils/constants/units";

export const demographicGraphicColors = {
  GRAPHIC_AGE: ["#142656", "#4260ad", "#6b8ce4", "#b7c9f8", "#e1e9fd", "#ccc", "#f1f1f1f1", "#1B4FEA"],
  GRAPHIC_SES: ["#5f280a", "#a35328", "#e88854", "#ffc6a7", "#ffe9dc", "#F35D0C"],
  GRAPHIC_EDU: ["#125c57", "#3b9c95", "#77c9c3", "#c9e6e4", "#f1f1f1", "#7FA09E"],
  GRAPHIC_MAR: ["#5c1220", "#a8364c", "#e6506d", "#eea0af", "#FFDDE4"],
};

export const socioeconomicStatusModalContent = {
  title: "Sosyo Ekonomik Durum",
  description:
    "Sosyoekonomik durum, yaşanabilirlik,refah ve kültür düzeyi puanlarının ortalaması alınarak hesaplanmıştır.",
  articles: [
    {
      articleTitle: "Yaşanabilirlik: ",
      articleContent:
        "Nüfus, konut yoğunluğu,sağlık kurumu,toplu taşıma, suç düzeyi, yaşam memnuniyet verilerine göre hesaplanmıştır.",
    },
    {
      articleTitle: "Refah Düzeyi: ",
      articleContent: "Satış ve kira değeri baz alınarak hesaplanmıştır.",
    },
    {
      articleTitle: "Kültür Düzeyi: ",
      articleContent: "Bölge halkının eğitim düzeyi ve kültürel tesis sayısına göre hesaplanmıştır.",
    },
    {
      articleTitle: "A+: ",
      articleContent: "Bölge halkının eğitim düzeyi ve kültürel tesis sayısına göre.",
    },
    {
      articleTitle: "A: ",
      articleContent: "Bölge halkının eğitim düzeyi ve kültürel tesis sayısına göre.",
    },
    {
      articleTitle: "B: ",
      articleContent: "Bölge halkının eğitim düzeyi ve kültürel tesis sayısına göre.",
    },
    {
      articleTitle: "C: ",
      articleContent: "Bölge halkının eğitim düzeyi ve kültürel tesis sayısına göre.",
    },
    {
      articleTitle: "D: ",
      articleContent: "Bölge halkının eğitim düzeyi ve kültürel tesis sayısına göre.",
    },
  ],
};

export const initialTradeTypes = [
  {
    key: "SALE",
    value: "Satılık",
    disabled: false,
  },
  {
    key: "RENT",
    value: "Kiralık",
    disabled: false,
  },
];

export const initialPriceTypes = [
  {
    key: Unit.M2.name,
    value: `${Unit.M2.name} Fiyatı`,
    disabled: false,
  },
  {
    key: "PRICE",
    value: "Fiyat",
    disabled: false,
  },
];

export const yearIndexEquals = {
  ONE_YEAR: 0,
  TWO_YEAR: 1,
  THREE_YEAR: 2,
  NEXT_YEAR: 3,
};

export const tradeTypeEquals = {
  Satılık: "SALE",
  Kiralık: "RENT",
  SALE: "SALE",
  sale: "SALE",
  rent: "RENT",
  RENT: "RENT",
};

export const graphicPriceYearTabs = [
  {
    key: "ONE_YEAR",
    value: "1 Yıl",
  },
  {
    key: "TWO_YEAR",
    value: "2 Yıl",
  },
  {
    key: "THREE_YEAR",
    value: "3 Yıl",
  },
  {
    key: "NEXT_YEAR",
    value: "1 Yıl Sonra",
  },
];

export const priceHistoryDescriptionText = {
  jetFirsat: {
    beforeLinkText: "Jetfırsatlar ilanlarının belirlenmesi için,",
    afterLinkText: `tarafından satış, saha çalışmaları ve internette yer alan verilere dayalı istatistiksel modelleme yöntemleri kullanılarak tahminler çıkarılmaktadır. Bu tahminler sapmalar içerebilir. Bu yöntemler, emlakjet.com’daki her satılık konut ilanı için muhtemel en yüksek ve en düşük fiyatı tahmin eder. Belirlenen fiyat aralığı doğrultusunda, sitemizde yayınlanan bir satılık konut ilanının fiyatı, belirlenen muhtemel en düşük fiyatından en az %30 daha düşük ise, ilan Jetfırsat olarak etiketlenmektedir. Jetfırsatlar kategorisi piyasa fiyatları karşısında avantajlı ilanları öngörmek amacını taşır, Jetfırsat ibaresi indirim anlamına gelmemektedir. Fiyatı gerçek olamayacak kadar düşük ilanların ön plana çıkarılmaması adına, ilanın fiyatı muhtemel en düşük fiyatın %50 ve daha altındaysa, ilan Jetfırsat etiketi alamaz. Burada yer alan bilgiler ve tahminler varsayımsal olup, herhangi bir taahhüt veya kesinlik içermez. Sadece tavsiye niteliğinde olup, öngörü amaçlıdır; herhangi bir şekilde Emlakjet, Endeksa veya müşteriler için hukuki bağlayıcılığı olamaz. Bu bilgi ve tahminlerin bir yatırıma veya ticarete konu edilmesi halinde Emlakjet ve Endeksa herhangi bir sorumluluk üstlenmez.`,
  },
  notJetFirsat: {
    beforeLinkText: "Bu ekrandaki tahminler",
    afterLinkText: `tarafından satış, saha çalışmaları ve internette yer alan verilere dayalı istatistiksel modelleme yöntemleri ile üretilmiştir ve sapmalar içerebilir. Burada yer alan bilgiler ve tahminler, varsayımsal olup herhangi bir taahhüt veya kesinlik içermez. Bu kapsamda buradaki bilgiler ve tahminler, müşteri için sadece tavsiye niteliğinde olup öngörü amaçlıdır; herhangi bir şekilde Emlakjet, Endeksa veya müşteriler için hukuki bağlayıcılığı olamaz. Bu bilgi ve tahminlerin bir yatırıma veya ticarete konu edilmesi halinde Emlakjet ve Endeksa herhangi bir sorumluluk üstlenmez.`,
  },
};
